import { Injectable } from '@angular/core';
import { HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { 
  ODataClient,
  ODataEntityService, 
  ODataEntity, 
  ODataEntities, 
  ODataProperty, 
  EntityKey,
  Duration,
  ODataEntityResource,
  ODataEntitySetResource,
  ODataNavigationPropertyResource,
  ODataActionResource,
  ODataFunctionResource,
  HttpOptions
} from 'angular-odata';

//#region ODataApi Imports
import { Firma } from '../entities/schema/firma.entity';
import { BookingObject } from '../entities/schema/bookingobject.entity';
import { BookingTimes } from '../entities/schema/bookingtimes.entity';
import { Type } from '../entities/ref/type.entity';
import { Status } from '../entities/settings/status.entity';
import { StatusType } from '../entities/settings/statustype.entity';
//#endregion

@Injectable()
export class BookingTimesService extends ODataEntityService<BookingTimes> {
  constructor(protected client: ODataClient) {
    super(client, 'BookingTimes', 'entities.schema.BookingTimes');
  }

  
  
  //#region ODataApi Actions
  //#endregion
  //#region ODataApi Functions
  //#endregion
  //#region ODataApi Navigations
  public bookingObjects(entity: EntityKey<BookingTimes>): ODataNavigationPropertyResource<BookingObject> {
    return this.entity(entity).navigationProperty<BookingObject>('bookingObjects');
  }
  public firma(entity: EntityKey<BookingTimes>): ODataNavigationPropertyResource<Firma> {
    return this.entity(entity).navigationProperty<Firma>('firma');
  }
  public status(entity: EntityKey<BookingTimes>): ODataNavigationPropertyResource<Status> {
    return this.entity(entity).navigationProperty<Status>('status');
  }
  public statusType(entity: EntityKey<BookingTimes>): ODataNavigationPropertyResource<StatusType> {
    return this.entity(entity).navigationProperty<StatusType>('statusType');
  }
  public type(entity: EntityKey<BookingTimes>): ODataNavigationPropertyResource<Type> {
    return this.entity(entity).navigationProperty<Type>('type');
  }
  //#endregion
}
